import { useCurrentStateAndParams } from '@uirouter/react';
import { useState, useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import utilSvc from '../../../../core/utilSvc';
import { pageStateAtom } from '../payor_edit_atoms';
import { pageStateVM } from '../payor_edit_view_models';
import { CLAIM_PAYOR_EDIT, ROUTE_CREATE } from '../../payor_const';
import { PageInit } from '../payor_edit_types';

export const usePayorEditInit = (): PageInit => {
    const route = useCurrentStateAndParams();
    const setState = useSetImmerAtom(pageStateAtom);
    const [title, setTitle] = useState('');

    // INIT
    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                // get context from Angular
                const ctx = ngContext();
                draft.canEdit = !!ctx && !!ctx.User ? utilSvc.user.hasFeature(ctx.User, CLAIM_PAYOR_EDIT) : false;

                // get mode / title / params from route
                draft.mode = route.state.name == ROUTE_CREATE ? 'CREATE' : 'UPDATE';
                draft.title = draft.mode == 'CREATE' ? 'Create Excluded Payor' : 'Edit Excluded Payor';
                draft.id = draft.mode == 'UPDATE' && !!route.params ? route.params.Id : '';

                // everything is settled off route
                draft.init = false;
                setTitle(draft.title);
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
        };
    }, [route, setState, setTitle]);

    return title;
};
